import React from 'react'
import Input from '../../UI/Input/Input'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import {updateObject, checkValidity} from '../../../shared/utility'
import './ZoneForm.css'
import Fade from 'react-reveal/Fade'
import FetchData from '../../../shared/fetchData'

        const ZoneForm = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [id, setId] = React.useState('')
    const [zone, setZone] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        if (props.edit == true) {
            const lckrTp = zone
            lckrTp.description.value = props.zone.description
            setZone(lckrTp)
            setEdit(true)
            setId(props.zone.id)
        }
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(zone, {
            [controlName]: updateObject(zone[controlName], {
                value: event.target.value
            })
        });
        setZone(updatedControls)
    }

    const zoneSubmit = (event) => {
        let valid = true
        const zn = zone
        for (let key in zn) {
            if (zn[key].value == '') {
                zn[key].valid = false
                valid = false
            }
        }
        if (!valid) {
            setZone(zn)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            if (!edit) {
                setLoading(true)
                const lckrTp = zone
                var raw = JSON.stringify({
                    "zone": {
                        "description": lckrTp.description.value
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/zones/insertZone'
                FetchData(raw, url).then(response => response.json())
                        .then(result => {
                            setLoading(false)
                            if (result.status == 0) {
                                props.toggleNewLockerForm(event, false)
                            }
                        })
                        .catch(error => setLoading(false))
            } else {
                setLoading(true)
                const lckrTp = zone
                var raw = JSON.stringify({
                    "zone": {
                        "id": id,
                        "description": lckrTp.description.value
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/zones/updateZone'
                FetchData(raw, url).then(response => response.json())
                        .then(result => {
                            setLoading(false)
                            if (result.status == 0) {
                                props.toggleNewLockerForm(event, false)
                            }
                        })
                        .catch(error => setLoading(false))
            }
        }
    }

    const formElementsArray = [];
    for (let key in zone) {
        formElementsArray.push({
            id: key,
            config: zone[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        let col = '6 mt-2'
        if (formElement.config.elementConfig.type == 'textarea') {
            col = '12 mt-2'
        }
        return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    search={true}
                    col={col}
                    changed={(event) => inputChangedHandler(event, formElement.id)} />
                );
    })

    return (
            <Fade duration={200} left cascade>
                <div>
                    <div className='row justify-content-center'>
                        <div className='zn-cntnr'>
                            <ContentForm headetText='zone'>
                                <div className='zn-frm'>
                                    {form}
                                </div>
                                <div className='col-12'>
                                    <div className='row justify-content-center w-100 mt-3'>
                                        <div className='col-6 text-center'>
                                            <Button btnType="General" clicked={(event) => props.toggleNewLockerForm(event, false)}>برگشت</Button>
                                        </div>
                                        <div className='col-6 text-center'>
                                            <Button btnType="Success" clicked={zoneSubmit}>ثبت</Button>
                                        </div>
                                    </div>
                                </div>
                            </ContentForm>
                        </div>
                    </div>
                </div>
            </Fade>
            )
}

export default ZoneForm